module.exports = __webpack_public_path__ + "static/img/img_0685.1d2e6f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0685.jpg
// module id = XRxb
// module chunks = 0